<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
    <div class="paddingContent">
      <el-tabs @tab-click="handleClick">
        <el-tab-pane label="全部">
          <MoneyOrderItemVue orderStatus="" v-if="orderStatus === ''" />
        </el-tab-pane>
        <el-tab-pane label="待付款">
          <MoneyOrderItemVue orderStatus="1" v-if="orderStatus === '1'" />
        </el-tab-pane>
        <el-tab-pane label="已付款">
          <MoneyOrderItemVue orderStatus="2" v-if="orderStatus === '2'" />
        </el-tab-pane>
        <el-tab-pane label="待審覈">
          <MoneyOrderItemVue orderStatus="3" v-if="orderStatus === '3'" />
        </el-tab-pane>
        <el-tab-pane label="付款失敗">
          <MoneyOrderItemVue orderStatus="4" v-if="orderStatus === '4'" />
        </el-tab-pane>
        <el-tab-pane label="訂單取消">
          <MoneyOrderItemVue orderStatus="5" v-if="orderStatus === '5'" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import MoneyOrderItemVue from "./moneyOrderItem.vue";
export default {
  data() {
    return {
      navBlock: "訂單",
      navtitle: "所有訂單",
      orderStatus: ""
    };
  },
  created() {},

  destroyed() {},
  methods: {
    handleClick(tab, events) {
      this.orderStatus = tab.paneName;
      if (tab.paneName === "0") {
        this.orderStatus = "";
      }
    }
  },
  components: {
    NavBar,
    MoneyOrderItemVue
  }
};
</script>

<style lang="less" scoped>
@import "./el_tabs.less";
.content {
  .paddingContent {
    width: 100%;
    overflow: auto;
  }
}
@media screen and (min-width: 769px) {
  .paddingContent {
    min-width: 1210px;
  }
}
@media screen and (max-width: 769px) {
  .paddingContent {
    min-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/allOrder/moneyOrder.vue